<template>
  <div>
    <div class="text-left tw-text-white tw-items-center">
      <div class="tw-text-2xl tw-font-bold tw-mb-5 tw-flex tw-items-center tw-space-x-2">
        <span><v-icon>mdi-shield-crown</v-icon></span>
        <span>ADMINISTRATOR</span>
      </div>
      <v-card class="tw-rounded-xl tw-mb-5 tw-space-x-2 tw-w-full tw-p-4" color="#031b41">
        <v-btn
          class="tw-rounded-xl tw-mb-2"
          :color="`${$route.name == 'AdminCasinoGames' ? '#2b57fb' : '#0a356b'}  `"
          @click="goToCasinoGames"
          ><strong>CASINO GAMES</strong></v-btn
        >

        <v-btn
          class="tw-rounded-xl tw-mb-2"
          :color="`${$route.name == 'AdminCasinoManager' ? '#2b57fb' : '#0a356b'}  `"
          @click="goToCasinoManager"
          ><strong>Sorting Manager</strong></v-btn
        >

        <v-btn
          class="tw-rounded-xl tw-mb-2"
          :color="`${selectedProvider == casinoProv.name ? '#2b57fb' : '#0a356b'}  `"
          v-for="(casinoProv, i) in casinoProviders"
          :key="i"
          @click="goToCasino(casinoProv.name)"
          ><strong>{{ casinoProv.name }} Casino</strong></v-btn
        >
      </v-card>
    </div>
  </div>
</template>

<script>
import GameSearch from "../../components/GameSearch.vue";
export default {
  props: ["casinoProviders", "selectedProvider"],
  components: {
    GameSearch,
  },
  methods: {
    goToCasinoGames() {
      this.$router.push("/admin/casino-games");
    },
    goToCasinoManager() {
      this.$router.push("/admin/casino-manager");
    },
    goToCasino(provider) {
      this.$emit("onGoToCasino", provider);
    },
  },
};
</script>
